import React from 'react';
import { GenericFields } from '../../../api/services/next';
import DropDown from '../dropdown';

const GenericMultipleFieldValuesDropDown = ({ ...rest }) => {
    return (
        <DropDown
            textField='Value'
            valueField='Id'
            api={GenericFields.GetGenericFieldsValues}
            {...rest}
        />
    );
};

export default GenericMultipleFieldValuesDropDown;
